import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import { useAuth } from '../context/AuthContext';
import SunIllustration from '../components/SunIllustration';

export default function LoginScreen({ navigation }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login, loading } = useAuth();

  async function handleLogin() {
    if (!email || !password) {
      Alert.alert('Error', 'Please enter email and password');
      return;
    }
    const result = await login(email, password);
    if (!result.success) {
      Alert.alert('Login Failed', result.error || 'Please try again');
    }
  }

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.inner}>
        <View style={styles.sunWrap}>
          <SunIllustration size={90} />
        </View>

        <View style={styles.form}>
          <Text style={styles.label}>Email address</Text>
          <TextInput
            style={styles.input}
            placeholder="Email address"
            placeholderTextColor="rgba(255,255,255,0.45)"
            value={email}
            onChangeText={setEmail}
            keyboardType="email-address"
            autoCapitalize="none"
          />

          <Text style={styles.label}>Password</Text>
          <View style={styles.passwordWrap}>
            <TextInput
              style={[styles.input, { paddingRight: 44 }]}
              placeholder="Password"
              placeholderTextColor="rgba(255,255,255,0.45)"
              value={password}
              onChangeText={setPassword}
              secureTextEntry={!showPassword}
            />
            <TouchableOpacity style={styles.eyeButton} onPress={() => setShowPassword(!showPassword)}>
              <Icon name={showPassword ? 'eye' : 'eye-off'} size={20} color={Colors.textLight} />
            </TouchableOpacity>
          </View>
          <TouchableOpacity>
            <Text style={styles.forgot}>Forgot password?</Text>
          </TouchableOpacity>
        </View>

        <TouchableOpacity style={styles.loginButton} onPress={handleLogin} disabled={loading}>
          <Text style={styles.loginButtonText}>{loading ? 'Logging in...' : 'Log In'}</Text>
        </TouchableOpacity>

        <Text style={styles.orText}>or log in with</Text>
        <View style={styles.socialRow}>
          {['logo-facebook', 'logo-google', 'logo-apple'].map(icon => (
            <TouchableOpacity key={icon} style={styles.socialButton}>
              <Icon name={icon} size={22} color="#fff" />
            </TouchableOpacity>
          ))}
        </View>

        <View style={styles.bottomRow}>
          <Text style={styles.bottomText}>{"Don't have an account? "}</Text>
          <TouchableOpacity onPress={() => navigation.navigate('SignUp')}>
            <Text style={styles.linkText}>Sign up now</Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.splashBot },
  inner: { flex: 1, paddingHorizontal: 32 },
  sunWrap: { alignItems: 'center', marginVertical: 24 },
  form: { marginBottom: 20 },
  label: { color: '#fff', fontSize: 14, fontWeight: '600', marginBottom: 6 },
  input: {
    backgroundColor: 'rgba(255,255,255,0.25)',
    borderRadius: 10,
    padding: 13,
    paddingHorizontal: 16,
    color: '#fff',
    fontSize: 15,
    marginBottom: 14,
  },
  passwordWrap: { position: 'relative' },
  eyeButton: { position: 'absolute', right: 14, top: 14 },
  forgot: { textAlign: 'right', color: 'rgba(255,255,255,0.8)', fontSize: 13, marginTop: -6 },
  loginButton: {
    backgroundColor: Colors.coral,
    paddingVertical: 14,
    borderRadius: 25,
    alignItems: 'center',
    alignSelf: 'center',
    width: '60%',
    marginTop: 20,
  },
  loginButtonText: { color: '#fff', fontSize: 16, fontWeight: '600' },
  orText: { textAlign: 'center', color: 'rgba(255,255,255,0.7)', fontSize: 13, marginTop: 20 },
  socialRow: { flexDirection: 'row', justifyContent: 'center', gap: 16, marginTop: 10 },
  socialButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottomRow: { flexDirection: 'row', justifyContent: 'center', marginTop: 24 },
  bottomText: { color: 'rgba(255,255,255,0.8)', fontSize: 13 },
  linkText: { color: Colors.accent, fontSize: 13, fontWeight: '600' },
});
